import React, { useState, useEffect } from "react";
import { MDBRow, MDBBtnGroup, MDBBtn } from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import axios from "axios";
import Skeleton from "@mui/material/Skeleton";
// config
import configData from "../config/config.json";
// components
import MetaTagsBusinessOwners from "../components/meta-tags-seo/MetaTagsBusinessOwners";
import RegisterBusiness from "./RegisterBusiness";
import Modal from "../components/registerbusiness-s5-modal/Modal";
// img
import imgg from "../images/register-business/05.png";

const RegisterBusinessStep5 = (props) => {
  const [dataCome, setDataCome] = useState(false);
  const [disable, setDisable] = useState(false);

  const [responseLoad, setresponseLoad] = useState({});
  const [responseLoadTT, setresponseLoadTT] = useState(false);

  const [daysHours, setdaysHours] = useState({});

  const [render, setRender] = useState(false);

  const [isOnline, setOnline] = useState(false);
  const [isFull, setFull] = useState(false);
  const clickHandler1 = () => {
    setOnline(!isOnline);
  };
  const clickHandler2 = () => {
    setFull(!isFull);
  };
  const [isOpen, setOpen] = useState(false);
  const [isClose, setClose] = useState(false);
  const clickHandler3 = () => {
    if (!isOpen) {
      //false
      setOpen(true);
      setClose(false);
    } else {
      //true
      setOpen(false);
      setClose(false);
    }
  };
  const clickHandler4 = () => {
    if (!isClose) {
      //false
      setClose(true);
      setOpen(false);
    } else {
      //true
      setClose(false);
      setOpen(false);
    }
  };
  const [timeData1, setTimeData1] = useState({});
  const [timeData2, setTimeData2] = useState({});
  const [timeData3, setTimeData3] = useState({});
  const [timeData4, setTimeData4] = useState({});
  const [timeData5, setTimeData5] = useState({});
  const [timeData6, setTimeData6] = useState({});
  const [timeData7, setTimeData7] = useState({});

  const submitHandler = (event) => {
    event.preventDefault();
    setDisable(true);

    const dataPost = {
      bId: getCookie("BizId"),
      isOnline: isOnline,
      open24Hours: isFull,
      holidayStatus: isOpen,
      workHours: responseLoad,
    };

    axios
      .post(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/workTimes`,
        dataPost,
        {
          headers: {
            ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
            LangId: 1,
            Authorization: "Bearer " + getCookie("token"),
          },
        }
      )
      .then((response) => {
        setDisable(false);
        if (response.data.isSuccess) {
          // success
          localStorage.removeItem("step6-back-data"); // remove data of step6 saved by back button

          props.history.push({
            pathname: "/register-business-step7",
          });
        }
      })
      .catch((error) => {
        // alert(error);
      });
  };

  const backHandler = () => {

    const dataLocal = {
      days: responseLoad,
      hours: daysHours,
      holidayStatus: isOpen,
      isOnline: isOnline,
      open24Hours: isFull,
    };
    localStorage.setItem("step6-back-data", JSON.stringify(dataLocal)); //set step6 loocal storage

    props.history.push({
      pathname: "/register-business-step5",
    });
  };

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "register-business-step6",
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    setDataCome(false);
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else {
      // api for meta tags
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });

      // api to check and get data
      axios
        .get(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/workTimes`, // the business Guuid that gets from login
          {
            headers: headerMeta,
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            let stepStatus = response.data.data.stepStatus;
            let data = response.data.data;

            // check user is registered or not
            if (!stepStatus.isRegistered) {
              props.history.push({
                pathname: "/signup",
              });
            }
            // check the business steps are completed or not
            else if (stepStatus.isComplete) {
              props.history.push({
                pathname: "/business-dashboard",
              });
            }
            // check the business step number
            else if (stepStatus.regStep < 6) {
              props.history.push({
                pathname: `/register-business-step${stepStatus.regStep}`,
              });
            } else {
              // success
              if (JSON.parse(localStorage.getItem("step6-back-data"))) {
                // set data from local storage to states
                data = JSON.parse(localStorage.getItem("step6-back-data"));
              } else {
                // set data from api to states
                data = response.data.data;
              }

              setDataCome(true);

              setClose(!data.holidayStatus);
              setOpen(data.holidayStatus);
              setOnline(data.isOnline);
              setFull(data.open24Hours);
              setdaysHours(data.hours);
              setresponseLoad(data.days);
              setresponseLoadTT(true);

              setRender(true);
            }
          }
        })
        .catch((error) => {
          alert(error);
        });
    }
  }, []);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return (
    <>
      {render ? (
        <>
          {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

          <RegisterBusiness />
          <div>
            <MDBRow className="mx-0">
              <div className="col-12 col-md-8 register-business-padd">
                <div className="register-steps-right">
                  <h1 className="rb-step5-tit1">روزها و ساعات کاری</h1>
                  {dataCome ? (
                    <div className="rb-s5-group2">
                      <button
                        className={
                          isOnline
                            ? "rb-s5-group2-btn-on"
                            : "rb-s5-group2-btn-off"
                        }
                        onClick={clickHandler1}
                      >
                        کسب‌و‌کار آنلاین است
                      </button>
                      <button
                        className={
                          isFull
                            ? "rb-s5-group2-btn-on"
                            : "rb-s5-group2-btn-off"
                        }
                        onClick={clickHandler2}
                      >
                        کسب‌و‌کار شبانه‌روزی است
                      </button>
                    </div>
                  ) : (
                    <div className="rb-s5-group2">
                      <Skeleton
                        className="bg-skeleton border-0 rb-s5-group2-btn-off "
                        variant="rectangular"
                        height={41.5}
                        animation="wave"
                      />{" "}
                      <Skeleton
                        className="bg-skeleton border-0 rb-s5-group2-btn-off"
                        variant="rectangular"
                        height={41.5}
                        animation="wave"
                      />
                    </div>
                  )}
                  {dataCome ? (
                    <div className="">
                      {/* {console.log("responseLoad")}
                    {console.log(responseLoad)} */}
                      {responseLoadTT && (
                        <Modal
                          // responseLoadTT={responseLoadTT}
                          // setresponseLoadTT={setresponseLoadTT}
                          isFull={isFull}
                          daysHours={daysHours}
                          responseLoad={responseLoad}
                          setresponseLoad={setresponseLoad}
                          timeData1={timeData1}
                          setTimeData1={setTimeData1}
                          timeData2={timeData2}
                          setTimeData2={setTimeData2}
                          timeData3={timeData3}
                          setTimeData3={setTimeData3}
                          timeData4={timeData4}
                          setTimeData4={setTimeData4}
                          timeData5={timeData5}
                          setTimeData5={setTimeData5}
                          timeData6={timeData6}
                          setTimeData6={setTimeData6}
                          timeData7={timeData7}
                          setTimeData7={setTimeData7}
                        />
                      )}
                    </div>
                  ) : (
                    <Skeleton
                      className="bg-skeleton border-0 s5-modal-btn mx-auto mx-md-0"
                      variant="rectangular"
                      height={50.7}
                      animation="wave"
                    />
                  )}

                  <p className="rb-step5-tit2">تعطیلات رسمی دولتی:</p>
                  {dataCome ? (
                    <MDBBtnGroup className="rb-s5-group">
                      <button
                        className={
                          isClose ? "rb-s5-group-btn-on" : "rb-s5-group-btn-off"
                        }
                        onClick={clickHandler4}
                      >
                        بسته است
                      </button>
                      <button
                        className={
                          isOpen ? "rb-s5-group-btn-on" : "rb-s5-group-btn-off"
                        }
                        onClick={clickHandler3}
                      >
                        باز است
                      </button>
                    </MDBBtnGroup>
                  ) : (
                    <div className="rb-s5-group">
                      <Skeleton
                        className="bg-skeleton border-0 rb-s5-group-btn-off"
                        variant="rectangular"
                        height={40.5}
                        animation="wave"
                      />{" "}
                      <Skeleton
                        className="bg-skeleton border-0 rb-s5-group-btn-off"
                        variant="rectangular"
                        height={40.5}
                        animation="wave"
                      />
                    </div>
                  )}

                  <div className="mt-1">
                    {dataCome ? (
                      <div className="rb-steps-btns">
                        <Link
                          // to="/register-business-step5"
                          className="rb-steps-btn1 hov-shadow"
                          onClick={backHandler}
                        >
                          مرحله قبلی
                        </Link>
                        <MDBBtn
                          disabled={disable}
                          className="rb-steps-btn2 hov-shadow"
                          onClick={submitHandler}
                        >
                          مرحله بعدی
                        </MDBBtn>
                      </div>
                    ) : (
                      <div className="rb-steps-btns">
                        <Skeleton
                          className="rb-steps-btn2 h-Skeleton-39"
                          variant="rectangular"
                          width={123}
                          height={39}
                          animation="wave"
                        />
                        <Skeleton
                          className="rb-steps-btn2 h-Skeleton-39"
                          variant="rectangular"
                          width={123}
                          height={39}
                          animation="wave"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 px-0 text-center d-md-block d-none">
                <img
                  className="register-business-img"
                  src={imgg}
                  alt="register business"
                />
              </div>
            </MDBRow>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default RegisterBusinessStep5;
